import SalesChannel from 'services/SalesChannel';
import React from 'react';

const api = PROJECT_ENV;

const assetsJson = 'https://apijumboweb.smdigital.cl/proxy/api/v1/json';

const jsonData = {
    promotions: `${assetsJson}/promotions.json`,
    categories: `${assetsJson}/categories.json`,
    cms: `${assetsJson}/cms`
}

const version = VERSION_ENV;
const urlPath = PATH_ENV || '';

const maxItemsExpress = 180;

const basicPayload = {
    "orderItems": [],
    "expectedOrderFormSections": [
        "items",
        "totalizers",
        "clientProfileData",
        "shippingData",
        "paymentData",
        "sellers",
        "messages",
        "marketingData",
        "clientPreferencesData",
        "storePreferencesData",
        "giftRegistryData",
        "ratesAndBenefitsData",
        "openTextField",
        "commercialConditionData",
        "customData"
    ],
    "noSplitItem": true
};

const criterias = [
    {
        id: 6,
        index: 0,
        title: 'Criterio Jumbo',
        value: 'Criterio Jumbo',
        className: 'jumbo-icon-short-logo criterio-jumbo',
        info: <><ul><li className="cart-susbstitution-criterio-jumbo-info"><strong className="cart-substitution-info-title">¿Qué es el criterio Jumbo?</strong></li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Ante un producto sin stock, buscaremos otro de reemplazo.</li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Mantendremos la marca, pero en otro formato. </li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Mantendremos características especiales (ligth, diet o sin lactosa).</li><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Si no encontramos el adecuado, buscaremos otra marca o sabor.</li></ul></>
    },
    {
        id: 2,
        index: 1,
        title: 'No sustituir',
        value: 'No sustituir',
        className: 'jumbo-icon-block',
        info: <><ul><li className="cart-susbstitution-criterio-jumbo-info"><i className="cart-substitution-criterio-jumbo-icon"></i>Si un producto no estuviera disponible, no será sustituido (<strong>ni cobrado</strong>), sin embargo si encontráramos un sustituo adecuado, te llamaremos para ofrecértelo como reemplazo.</li></ul></>
    }
];

const salesChannel = () => {
    return SalesChannel.getSalesChannel();
};

const nameSalesChannel = SalesChannel.getSalesChannelName();

const nameMethod = SalesChannel.getMethodName();

const sellerIdFood = "1";

const imageUrl = "https://jumbo.vteximg.com.br";
const defaultCategory = ["despensa"];

const googleMaps = {
    api: 'AIzaSyBwPqTrJhATFWl0INf5V2KhAjukgWib_Ws'
};
const rutRegex = /^[0-9]{1,2}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9Kk]{1}$/;

const tlfnRegex = /^[+]{0,1}[0-9]{9,11}$/;

const tlfnSmallRegex = /^[0-9]{8,10}$/;

const emailRegex = /^(([^<>()[\]\\.,;:ñáéíóúèàìòù´`$¢\s@"]+(\.[^<>()[\]\\.,;:ñáéíóúèàìòù`´$¢\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const maxItemsOSM = 60;

const catId = '560102';
const catOnClickId = '202';

const methodToSla = {
    'seller-1-sla-DespachoaDomicilio': 'Despacho a Domicilio',
    'seller-1-sla-RetiroenTienda': 'Retiro en Tienda',
    'seller-1-sla-ClickalAuto': 'Click al Auto',
    'seller-1-sla-Express': 'Express'
}

const salesChannelBO = [
    {
        "id": 22,
        "nombre": "El llano"
    },
    {
        "id": 28,
        "nombre": "Ñuñoa"
    },
    {
        "id": 31,
        "nombre": "Kennedy"
    },
    {
        "id": 32,
        "nombre": "Concha y toro"
    },
    {
        "id": 37,
        "nombre": "Peñalolen"
    },
    {
        "id": 38,
        "nombre": "Independencia"
    },
    {
        "id" : 39,
        "nombre":"costanera"
    },
    {
        "id" : 40,
        "nombre":"San Bernardo"
    }
];

const expressFlag = false;
const notificationsFlag = true;
const showTermsModal = false;

export {
    api,
    sellerIdFood,
    salesChannel,
    nameSalesChannel,
    nameMethod,
    imageUrl,
    defaultCategory,
    basicPayload,
    googleMaps,
    rutRegex,
    emailRegex,
    tlfnRegex,
    tlfnSmallRegex,
    maxItemsOSM,
    catId,
    maxItemsExpress,
    criterias,
    methodToSla,
    expressFlag,
    catOnClickId,
    version,
    jsonData,
    notificationsFlag,
    salesChannelBO,
    urlPath,
    showTermsModal
};
